import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
export default {
  name: "im-group-send-message",
  data: function data() {
    return {
      searchForm: {
        page: 1,
        count: 15,
        price: [],
        city_id: "",
        district_id: [],
        subway_id: "",
        gender: "",
        promotion_count_min: "",
        promotion_count_max: "0",
        last_promoted_at: parseInt(new Date().getTime() - 2 * 24 * 3600 * 1000) || "",
        order: "-last_logined_at"
      },
      // 搜索表单

      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      messageTemplate: "",
      message: "",
      user_id_list: [],
      multipleSelection: [],
      cityList: [],
      districtList: [],
      subwayList: [],
      houseCode: ""
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getCityList();
            if (_this.$route.query.houseId) {
              _this.getHouseInfo();
              _this.message = "https://www.wellcee.com/rent-apartment/".concat(_this.$route.query.houseId);
            } else {
              _this.getData();
            }
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    getHouseInfo: function getHouseInfo() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, rent;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.getHouseInfo({
                id: _this2.$route.query.houseId
              });
            case 1:
              res = _context2.v;
              _this2.searchForm.city_id = res.data.cityId;
              _context2.n = 2;
              return _this2.getDistrictList();
            case 2:
              _this2.searchForm.district_id = [res.data.districtId];
              rent = res.data.rent;
              _this2.houseCode = res.data.houseCode;
              if (rent >= 0) {
                _this2.searchForm.price = ["0"];
              }
              if (rent >= 1500) {
                _this2.searchForm.price = ["1500"];
              }
              if (rent >= 2500) {
                _this2.searchForm.price = ["2500"];
              }
              if (rent >= 3500) {
                _this2.searchForm.price = ["3500"];
              }
              if (rent >= 5000) {
                _this2.searchForm.price = ["5000"];
              }
              if (rent >= 8000) {
                _this2.searchForm.price = ["8000"];
              }
              if (rent >= 12000) {
                _this2.searchForm.price = ["12000"];
              }
              _this2.getData();
              console.log(res.data);
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    resetSearch: function resetSearch() {
      this.searchForm = {
        page: 1,
        count: 30,
        price: [],
        city_id: "",
        district_id: [],
        subway_id: "",
        gender: "",
        promotion_count_min: "",
        promotion_count_max: "0",
        last_promoted_at: parseInt(new Date().getTime() - 2 * 24 * 3600 * 1000) || "",
        order: "-last_logined_at"
      };
      this.getData();
    },
    getCityList: function getCityList() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.$api.getCityListByPy();
            case 1:
              res = _context3.v;
              _this3.cityList = res.data;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getDistrictList: function getDistrictList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this4.$api.getDistrictListByPy({
                city_id: _this4.searchForm.city_id
              });
            case 1:
              res = _context4.v;
              _this4.districtList = res.data;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getSubwayList: function getSubwayList() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this5.$api.getSubwayListByPy({
                city_id: _this5.searchForm.city_id
              });
            case 1:
              res = _context5.v;
              _this5.subwayList = res.data;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    cityChange: function cityChange() {
      if (this.searchForm.city_id) {
        this.getDistrictList();
        this.getSubwayList();
      }
      this.searchForm.district_id = [];
      this.searchForm.subway_id = "";
    },
    pageChange: function pageChange(pn) {
      this.searchForm.page = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var searchForm, res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (type === "search") {
                _this6.searchForm.page = 1;
              }
              searchForm = {};
              if (_this6.searchForm.price.length > 0) {
                searchForm.price = _this6.searchForm.price.join(",");
              }
              if (_this6.searchForm.city_id) {
                searchForm.city_id = _this6.searchForm.city_id;
              }
              if (_this6.searchForm.district_id.length > 0) {
                searchForm.district_id = _this6.searchForm.district_id.join(",");
              }
              if (_this6.searchForm.subway_id) {
                searchForm.subway_id = _this6.searchForm.subway_id;
              }
              if (_this6.searchForm.last_promoted_at) {
                searchForm.last_promoted_at = parseInt(new Date(_this6.searchForm.last_promoted_at).getTime() / 1000);
              }
              if (_this6.searchForm.gender) {
                searchForm.gender = _this6.searchForm.gender;
              }
              if (_this6.searchForm.promotion_count_min) {
                searchForm.promotion_count_min = _this6.searchForm.promotion_count_min;
              }
              if (_this6.searchForm.promotion_count_max) {
                searchForm.promotion_count_max = _this6.searchForm.promotion_count_max;
              }
              searchForm.page = _this6.searchForm.page - 1;
              searchForm.count = _this6.searchForm.count;
              searchForm.order = _this6.searchForm.order;
              _this6.tableLoading = true;
              _context6.n = 1;
              return _this6.$api.getGroupSendMessageUserList(searchForm);
            case 1:
              res = _context6.v;
              _this6.tableData = res.data;
              _this6.total = res.page.count;
              _this6.messageTemplate = res.page.message_template;
              _this6.tableLoading = false;
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    getRowKeys: function getRowKeys(row) {
      return row.user_id;
    },
    handleSelectionChange: function handleSelectionChange(val) {
      console.log(val);
      this.multipleSelection = val;
    },
    groupSendMessage: function groupSendMessage() {
      var _this7 = this;
      this.user_id_list = [];
      this.multipleSelection.forEach(function (item) {
        _this7.user_id_list.push(item.user_id);
      });
      if (!this.message) {
        this.$message.error("请输入消息内容");
        return false;
      }
      if (this.user_id_list.length == 0) {
        this.$message.error("请选择接收人");
        return false;
      }
      this.$confirm("是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var res;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return _this7.$api.groupSendMessage({
                message: _this7.message,
                user_id_list: _this7.user_id_list.join(",")
              });
            case 1:
              res = _context7.v;
              if (!(res.code == 0)) {
                _context7.n = 3;
                break;
              }
              if (!_this7.$route.query.promoteId) {
                _context7.n = 2;
                break;
              }
              _context7.n = 2;
              return _this7.$api.updatePromote({
                id: _this7.$route.query.promoteId,
                im_push_num: _this7.user_id_list.length
              });
            case 2:
              // 操作上报
              _this7.$operationLog.push({
                operationType: "house",
                code: "send",
                houseCode: _this7.houseCode,
                houseId: _this7.$route.query.houseId
              });
              _this7.$message.success("发送成功");
              _this7.message = "";
              _this7.getData();
              _this7.user_id_list = [];
              _this7.multipleSelection = [];
              _this7.$refs.multipleTable.clearSelection();
              _context7.n = 4;
              break;
            case 3:
              _this7.$message.error(res.message);
            case 4:
              return _context7.a(2);
          }
        }, _callee7);
      }))).catch(function () {});
    }
  }
};